module.exports = __webpack_public_path__ + "128367ea6eb9a66b333aa50fd0f7fa0f.svg";